import createIcon from '../../createIcon';

/**
 * @component @name BedroomBaby
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMkg0QzIuOSAyIDIgMi45IDIgNFYyMEMyIDIxLjEgMi45IDIyIDQgMjJIMjBDMjEuMSAyMiAyMiAyMS4xIDIyIDIwVjRDMjIgMi45IDIxLjEgMiAyMCAyWk0xMiAxOEM5LjM2IDE4IDYuODcgMTYuOTcgNSAxNS4xTDYuMDYgMTQuMDRDNi40IDE0LjM4IDYuNzcgMTQuNjkgNy4xNiAxNC45Nkw4IDEzLjVWOS41MUw2LjQ1IDEwLjVMNS41IDkuNUw3IDcuNzZMNiA3SDkuNjVMMTEuMzggMTBIMTdWMTFIMTZWMTMuNUwxNi44NCAxNC45NkMxNy4yMyAxNC42OCAxNy42IDE0LjM4IDE3Ljk0IDE0LjA0TDE5IDE1LjFDMTcuMTMgMTYuOTcgMTQuNjQgMTggMTIgMThaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTQuNjkgMTQuMjRDMTIuOTUgMTQuODkgMTEuMDMgMTQuODkgOS4yOSAxNC4yNEw4LjQ4IDE1LjY1TDguNDUgMTUuNzFDOS41NSAxNi4yMyAxMC43MyAxNi41IDExLjk4IDE2LjVDMTMuMjMgMTYuNSAxNC40MyAxNi4yMiAxNS41MyAxNS43MUwxNS41IDE1LjY1TDE0LjY5IDE0LjI0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BedroomBaby = createIcon('BedroomBaby', [
  [
    'path',
    {
      d: 'M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM12 18C9.36 18 6.87 16.97 5 15.1L6.06 14.04C6.4 14.38 6.77 14.69 7.16 14.96L8 13.5V9.51L6.45 10.5L5.5 9.5L7 7.76L6 7H9.65L11.38 10H17V11H16V13.5L16.84 14.96C17.23 14.68 17.6 14.38 17.94 14.04L19 15.1C17.13 16.97 14.64 18 12 18Z',
      key: '19yozb',
    },
  ],
  [
    'path',
    {
      d: 'M14.69 14.24C12.95 14.89 11.03 14.89 9.29 14.24L8.48 15.65L8.45 15.71C9.55 16.23 10.73 16.5 11.98 16.5C13.23 16.5 14.43 16.22 15.53 15.71L15.5 15.65L14.69 14.24Z',
      key: '1pz9ql',
    },
  ],
]);

export default BedroomBaby;
